"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Modal = _interopRequireDefault(require("antd/lib/modal/Modal"));

require("moment/locale/zh-cn");

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
// const { Option } = Select;
var ValidForm = function ValidForm(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      item = _ref.item,
      duplicateMatch = _ref.duplicateMatch;

  // let cl = localStorage.getItem("CL");
  // let token = localStorage.getItem("token");
  // const [form] = Form.useForm();
  // const history = useHistory();
  // const [apiError, setapiError] = useState(null);
  // const [formVisible,setFormVisible] = useState(visible);
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      apiError = _useState2[0];

  var _useState3 = (0, _react.useState)(visible),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 1),
      formVisible = _useState4[0];

  (0, _react.useEffect)(function () {}, [item]);

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_Modal.default, {
    title: "".concat(item.length, " Duplicate Details"),
    centered: true,
    visible: formVisible,
    onCancel: onCancel,
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    },
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    bodyStyle: {
      overflowY: 'scroll',
      height: 500
    }
  }, item.map(function (i1, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, index + 1), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Token No : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Token_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "RM Code : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.RM_code)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Student Name : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Student_name)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Mother Name : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Mother_name)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Parent Status : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Parent_status)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "School Type : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.School_type)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Joining Date : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, dateFormate(i1.Joining_date))), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "CL_code : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.CL_code)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10,
      style: {
        color: i1.WhatsApp_no === duplicateMatch.WhatsApp_no || i1.Calling_no === duplicateMatch.Calling_no || i1.WhatsApp_no === duplicateMatch.Calling_no ? 'red' : ''
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "WhatsApp No : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10,
      style: {
        color: i1.WhatsApp_no === duplicateMatch.WhatsApp_no || i1.Calling_no === duplicateMatch.Calling_no || i1.WhatsApp_no === duplicateMatch.Calling_no ? 'red' : ''
      }
    }, i1.WhatsApp_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10,
      style: {
        color: i1.WhatsApp_no === duplicateMatch.WhatsApp_no || i1.Calling_no === duplicateMatch.Calling_no || i1.WhatsApp_no === duplicateMatch.Calling_no ? 'red' : ''
      }
    }, /*#__PURE__*/_react.default.createElement("b", null, "Calling No : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10,
      style: {
        color: i1.WhatsApp_no === duplicateMatch.WhatsApp_no || i1.Calling_no === duplicateMatch.Calling_no || i1.WhatsApp_no === duplicateMatch.Calling_no ? 'red' : ''
      }
    }, i1.Calling_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "DOB : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, dateFormate(i1.DOB))), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Class : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Class)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "School Fee : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.School_fee)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "English Mode Status : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.English_mode_status)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "English Label : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.English_label)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "English Worksheet No : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.English_worksheet_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Math Mode Status : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Mode_status)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Math Label : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Label)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Math Worksheet No : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Worksheet_no)), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, /*#__PURE__*/_react.default.createElement("b", null, "Subject : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      span: 10
    }, i1.Subject)), /*#__PURE__*/_react.default.createElement(_antd.Divider, null));
  }));
};

var _default = ValidForm;
exports.default = _default;